import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(detector) // passes i18n down to react-i18next
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(Backend)
  .init({
    ns: ["translation", "errors", "common"],
    backend: {
      loadPath:
        "https://storage.googleapis.com/rsvip-dictionaries/{{lng}}/{{ns}}.json",
      crossDomain: true,
    },

    fallbackLng: "en",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
